<template>
    <div>
        <page-header title="Recent Activity" >
          <template slot="secondary">
            <b-button variant="light" @click="$apollo.queries.calls.refetch()">Refresh Data</b-button>
          </template>
        </page-header>
        <b-container>
          <b-row>
            <b-col md="4">
              <b-card header="Filters">
                <b-form>
                  <b-form-group label="Start">
                    <b-form-datepicker v-model="startDate"></b-form-datepicker>
                  </b-form-group>
                  <b-form-group label="End">
                    <b-form-datepicker v-model="endDate"></b-form-datepicker>
                  </b-form-group>
                </b-form>
              </b-card>
            </b-col>
            <b-col md="8">
              <b-card v-for="activity in activities" class="mb-3" :key="activity.id">
                <template v-slot:header>
                  <b-img right :src="activity.icon"></b-img>
                  <div>{{activity.connector.name}} {{activity.verb}} {{activity.member.name}}</div>
                  <div class="text-muted">
                    {{activity.createdAt | moment('from')}}
                    <span v-if="activity.status"> | {{activity.status}}</span>
                  </div>
                </template>
                <component :is="activity.component" :activity="activity" :key="activity.id"></component>
              </b-card>
            </b-col>
          </b-row>
        </b-container>
    </div>
</template>
<script>

import PageHeader from '@/components/global/PageHeader';
import { Activity } from '@/gql/activity/Activity.gql';
import CallActivity from '@/components/activity/CallActivity.vue';
import NoteActivity from '@/components/activity/NoteActivity.vue';

export default {
  components:{
    PageHeader,
    CallActivity,
    NoteActivity,
  },
  data() {
    return {
      startDate: new Date(Date.now() - 24 * 3600 * 1000),
      endDate: new Date(),
      activities: []
    }
  },
  apollo: {
    calls: {
      query: Activity,
      variables() {
        let startDate = new Date(this.startDate);
        startDate.setHours(0,0,0,0);
        let endDate = new Date(this.endDate);
        endDate.setHours(23,59,59,999);
        return {
          since: startDate,
          until: endDate,
        };
      },
      result(resp) {
        this.activities = [];
        resp.data.calls.forEach((call) => {
          call.component = 'CallActivity';
          call.verb = 'called';
          call.icon = 'https://img.icons8.com/ios-filled/24/888888/phone-disconnected.png';
          this.activities.push(call);
        });
        resp.data.notes.forEach((note) => {
          note.component = 'NoteActivity';
          note.verb = 'wrote a note about';
          note.icon = 'https://img.icons8.com/ios-filled/24/888888/note.png';
          this.activities.push(note);
        })
        this.activities = this.activities.sort((a, b) => {
          return a.createdAt - b.createdAt;
        });
      }
    },
  },
  methods: {
    getBgVariant (status){
      return {
        'completed': 'success',
        'failed': 'danger',
        'no-answer': 'info'
      }[status]
    }
  }

}
</script>
